/**
 * Удаление HTML тегов из строки
 * @param str
 * @param phrase
 * @returns {void | string | *}
 */
const stripTags = (str, phrase) => str.replace(/<\/?[^>]+(>|$)/g, phrase || '')

export default stripTags
